const getBaseUrl = () => {
    // return 'http://localhost:3002/'
    return 'http://172.16.40.44:3002/'
};

export default getBaseUrl;